import { readonly, ref } from "vue";

const DEFAULT_SUCCESS_MESSAGE = "Збережено";
const DEFAULT_ERROR_MESSAGE = "Виникла помилка";

const toasts = ref([]);

export function useToast() {
  function show(type, message, options = {}) {
    toasts.value.push({
      ...options,
      id: crypto.randomUUID(),
      type,
      title: message,
    });
  }

  function success(message, options) {
    show("success", message || DEFAULT_SUCCESS_MESSAGE, options);
  }

  function error(message, options) {
    show("error", message || DEFAULT_ERROR_MESSAGE, options);
  }

  function remove(id) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return { toasts: readonly(toasts), success, error, remove };
}
